import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@/context/AuthContext'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { DeleteWithUndoProvider } from '@/components/shared/DeleteWithUndo'
import Layout from '@/layout/Layout'
import Dashboard from '@/pages/Dashboard'
import Apartments from '@/pages/Apartments'
import Clients from '@/pages/Clients'
import ClientProfile from '@/pages/ClientProfile'
import Contracts from '@/pages/Contracts'
import SalesAndPayments from '@/pages/SalesAndPayments'
import Reports from '@/pages/Reports'
import Home from '@/pages/Home'
import Users from '@/pages/Users'
import Login from '@/pages/Login'
import Register from '@/pages/Register'
import ForgotPassword from '@/pages/ForgotPassword'
import ResetPassword from '@/pages/ResetPassword'
import './App.css'

const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            
            {/* Protected routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/Dashboard" replace />} />
              <Route path="Dashboard" element={<Dashboard />} />
              <Route path="Apartments" element={<Apartments />} />
              <Route path="Clients" element={<Clients />} />
              <Route path="ClientProfile" element={<ClientProfile />} />
              <Route path="Contracts" element={<Contracts />} />
              <Route path="SalesAndPayments" element={<SalesAndPayments />} />
              <Route path="Reports" element={<Reports />} />
              <Route path="Users" element={<Users />} />
            </Route>

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/Dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
